interface SpinnerProps {
  fullPage?: boolean;
}

export function Spinner({ fullPage }: SpinnerProps) {
  if (fullPage) {
    return (
      <div className="page-loading">
        <span className="spinner" />
      </div>
    );
  }
  return <span className="spinner" />;
}
